import { CollectionKind, type CollectionOut } from '@/api/generated/schemas';

/** Kinds the admin must not resolve publications for: banners carry
 * creatives, and personal collections resolve per user — for both, the
 * publications endpoint answers with a number that means nothing. */
const NO_PUBLICATIONS: readonly CollectionKind[] = [
  CollectionKind.banner,
  CollectionKind.personal,
];

export const holdsPublications = (
  collection: CollectionOut | undefined
): boolean =>
  collection != null && !NO_PUBLICATIONS.includes(collection.collection_kind);

export type CollectionIssue = 'deleted' | 'mod_status';

/** Advisory problems with a lineup collection. An unresolved lookup
 * (`undefined`) means the collection is gone — callers must only ask once
 * their lookups settled. */
export const collectionIssues = (
  collection: CollectionOut | undefined
): CollectionIssue[] => {
  if (!collection) return ['deleted'];
  if (collection.deleted_at != null) return ['deleted'];
  return collection.mod_status === 'enabled' ? [] : ['mod_status'];
};
